import { createAction } from 'redux-actions'

import * as CONSTANT from '../constants/mallConstant'

export let fetchBanner = createAction(CONSTANT.FETCH_MALL_BANNER_DATA)
export let fetchBannerSuccess = createAction(CONSTANT.FETCH_MALL_BANNER_SUCCESS)
export let requestCatalogData = createAction(CONSTANT.REQUEST_CATALOG_DATA)
export let setCatalogData = createAction(CONSTANT.SET_CATALOG_DATA)
export let setCatalogState = createAction(CONSTANT.SET_CATALOG_STATE)

export let requestHotSaleData = createAction(CONSTANT.REQUEST_HOT_SALE_DATA)
export let setHotSaleData = createAction(CONSTANT.SET_HOT_SALE_DATA)
export let setHotSaleState = createAction(CONSTANT.SET_HOT_SALE_STATE)

export let requestHomeProductsData = createAction(CONSTANT.REQUEST_HOME_PRODUCTS_DATA)
export let setHomeProductsData = createAction(CONSTANT.SET_HOME_PRODUCTS_DATA)
export let setHomeProductsState = createAction(CONSTANT.SET_HOME_PRODUCTS_STATE)

export let requestProductListData = createAction(CONSTANT.REQUEST_PRODUCT_LIST_DATA)
export let setProductListData = createAction(CONSTANT.SET_PRODUCT_LIST_DATA)
export let setProductListState = createAction(CONSTANT.SET_PRODUCT_LIST_STATE)
export let setProductListIndex = createAction(CONSTANT.SET_PRODUCT_LIST_INDEX)
export let clearProductListSearch = createAction(CONSTANT.CLEAR_PRODUCT_LIST_SEARCH)

export let requestProductDetailsData = createAction(CONSTANT.REQUEST_PRODUCT_DETAILS_DATA)
export let setProductDetailsData = createAction(CONSTANT.SET_PRODUCT_DETAILS_DATA)
export let setProductDetailsState = createAction(CONSTANT.SET_PRODUCT_DETAILS_STATE)

export let requestCartData = createAction(CONSTANT.REQUEST_CART_DATA)
export let setCartData = createAction(CONSTANT.SET_CART_DATA)
export let setCartState = createAction(CONSTANT.SET_CART_STATE)
export let postCartItem = createAction(CONSTANT.POST_CART_ITEM)
export let putCartItem = createAction(CONSTANT.PUT_CART_ITEM)
export let deleteCartItem = createAction(CONSTANT.DELETE_CART_ITEM)

export let setOrderConfirmData = createAction(CONSTANT.SET_MALL_ORDER_CONFIRM_DATA)
export let setOrderConfirmCoupon = createAction(CONSTANT.SET_MALL_ORDER_CONFIRM_COUPON)

export let requestOrderListData = createAction(CONSTANT.REQUEST_MALL_ORDER_LIST_DATA)
export let setOrderListData = createAction(CONSTANT.SET_MALL_ORDER_LIST_DATA)
export let setOrderListState = createAction(CONSTANT.SET_MALL_ORDER_LIST_STATE)
export let setOrderListIndex = createAction(CONSTANT.SET_MALL_ORDER_LIST_INDEX)
export let setOrderListRefresh = createAction(CONSTANT.SET_MALL_ORDER_LIST_REFRESH)

